module.exports = __webpack_public_path__ + "static/media/card_brand_vr.33224b87.svg";